import { AnimateLayoutChanges, useSortable } from "@dnd-kit/sortable";
import { Icon } from "@mindlercare/ui-web";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";
import { CSSProperties } from "react";

const animateLayoutChanges: AnimateLayoutChanges = ({
  isSorting,
  wasDragging,
  isDragging,
}) => (isSorting || wasDragging || isDragging ? false : true);

type Props = {
  rowId: string;
};

export const Handle = ({ rowId }: Props) => {
  const { listeners, setNodeRef, isDragging, attributes } = useSortable({
    id: rowId,
    animateLayoutChanges,
  });

  const style: CSSProperties = {
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 1 : 0,
    position: "relative",
    cursor: isDragging ? "grabbing" : "grab",
    color: defaultTheme.COLORS.GRAY,
  };

  return (
    <span style={style} ref={setNodeRef} {...listeners} {...attributes}>
      <Icon.DragHandle />
    </span>
  );
};
